/** "Oct 6, 2026" or, with `time`, "Oct 6, 2026, 15:09" (24h) in the browser's time zone. Invalid input is shown as given. */
export const formatDate = (value: string | number | Date | null | undefined, { time = false }: { time?: boolean } = {}): string => {
    if (value == null || value === '' || (typeof value === 'number' && !Number.isFinite(value))) return '—';
    // A bare `YYYY-MM-DD` is a calendar date: parse it as local so it never shows the previous day in UTC-negative zones.
    const dateOnly = typeof value === 'string' ? /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim()) : null;
    const date = dateOnly ? new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3])) : new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);
    const day = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    if (!time) return day;
    const clock = date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
    return `${day}, ${clock}`;
};

/** A number or numeric string with two decimals; anything else is shown as given (or a dash). */
export const formatAmount = (value: number | string | null | undefined): string => {
    if (value == null) return '—';
    const text = typeof value === 'string' ? value.trim() : value;
    if (text === '') return '—';
    const n = typeof text === 'number' ? text : Number(text);
    return Number.isFinite(n) ? n.toFixed(2) : String(value);
};
